import React from "react";
import { Link } from "react-router-dom";

const SuccessfulSubmit = ({ message, icon: Icon, link, linkName, red }) => {
  return (
    <>
      {red ? (
        <div className="flex flex-col items-center justify-center h-full gap-3 sm:p-10 lg:p-40">
          {<Icon size={150} className="text-red-500" />}
          <h3 className="text-center  text-3xl text-red-500 select-none">
            Successfuly Canceled
          </h3>
          <p className="text-center text-lg text-text-1/65 select-none">
            {message}
          </p>
          <Link
            to={link}
            replace
            className="add-rss-btn !bg-red-500  hover:!bg-red-600"
          >
            {linkName}
          </Link>
        </div>
      ) : (
        <div className="flex flex-col items-center justify-center h-full gap-3 sm:p-10 lg:p-40">
          {<Icon size={150} className="text-blue-500" />}
          <h3 className="text-center  text-3xl text-blue-500 select-none">
            Successful
          </h3>
          <p className="text-center text-lg text-text-1/65 select-none">
            {message}
          </p>
          <Link
            to={link}
            replace
            className="add-rss-btn !bg-blue-500  hover:!bg-blue-600"
          >
            {linkName}
          </Link>
        </div>
      )}
    </>
  );
};

export default SuccessfulSubmit;
